module.exports = __webpack_public_path__ + "img/LaMorning.70233e20.svg";